<table mat-table [dataSource]="dataSource" class="example-table table-rounded-corners" matSort matSortActive="deadlineInkoopDate"
  matSortDisableClear matSortDirection="asc" [trackBy]="trackById">

    <!-- isChanged Column -->
    <ng-container matColumnDef="isChanged">
      <th mat-header-cell *matHeaderCellDef disableClear [class.hide]="hasChanges()"></th>
      <td mat-cell *matCellDef="let row" [class.hide]="hasChanges()">
        <span *ngIf="row.isChanged" class="material-icons">
          unpublished
        </span>
      </td>
    
    </ng-container>

  <!-- regelNr Column -->
  <ng-container matColumnDef="regelNr">
    <th mat-header-cell *matHeaderCellDef mat-sort-header disableClear>#</th>
    <td mat-cell *matCellDef="let row">{{row.regelNr}}</td>
  </ng-container>

  <!-- debiteurNaam Column -->
  <ng-container matColumnDef="debiteurNaam">
    <th mat-header-cell *matHeaderCellDef mat-sort-header disableClear>Debiteur</th>
    <td mat-cell *matCellDef="let row"><div class="ellipsis" title="{{row.debiteurNaam}}">{{row.debiteurNaam}}</div></td>
  </ng-container>

  <!-- thumbnail Column -->
  <ng-container matColumnDef="thumbnail">
    <th mat-header-cell *matHeaderCellDef>Foto</th>
    <td mat-cell *matCellDef="let row">
      <img *ngIf="row.thumbnail != null" src="{{row.thumbnail}}" alt="Aanbod foto" class="kp-thumbnail"
        onerror="this.src='./assets/img/image-not-available.png';">
    </td>
  </ng-container>

  <!-- artikelNr Column -->
  <ng-container matColumnDef="artikelNr">
    <th mat-header-cell *matHeaderCellDef mat-sort-header disableClear>Artikelnr</th>
    <td mat-cell *matCellDef="let row">{{ row.leverancierDetails.supplierAssignedId || row.artikelNr}}</td>
  </ng-container>

  <!-- productNaam Column -->
  <ng-container matColumnDef="productNaam">
    <th mat-header-cell *matHeaderCellDef mat-sort-header disableClear>Product</th>
    <td mat-cell *matCellDef="let row"><div class="ellipsis" title="{{row.leverancierDetails.omschrijving || row.productNaam}}">{{row.leverancierDetails.omschrijving || row.productNaam}}</div></td>
  </ng-container>

  <!-- potmaat Column -->
  <ng-container matColumnDef="potmaat">
    <th mat-header-cell *matHeaderCellDef mat-sort-header disableClear>Potmaat</th>
    <td mat-cell *matCellDef="let row">{{row.potmaat}}</td>
  </ng-container>

  <!-- hoogte Column -->
  <ng-container matColumnDef="hoogte">
    <th mat-header-cell *matHeaderCellDef mat-sort-header disableClear>Hoogte</th>
    <td mat-cell *matCellDef="let row">{{row.vbnHoogte || row.hoogte}}</td>
  </ng-container>

  <!-- afleverperiodeVan Column -->
  <ng-container matColumnDef="afleverperiodeVan">
    <th mat-header-cell *matHeaderCellDef>Afleverperiode</th>
    <td mat-cell *matCellDef="let row">Week <span
        style="display: inline-block;width: 1.2em;text-align: end;">{{row.periodeVanWeekNr}}</span> -
      {{row.periodeTotWeekNr}}</td>
  </ng-container>

  <!-- deadlineInkoopDate Column -->
  <ng-container matColumnDef="deadlineInkoopDate">
    <th mat-header-cell *matHeaderCellDef mat-sort-header disableClear>Deadline</th>
    <td mat-cell *matCellDef="let row">{{row.deadlineInkoopDate | date:'dd-MM-yyyy'}} </td>
  </ng-container>

  <!-- aantalGevraagd Column -->
  <ng-container matColumnDef="aantalGevraagd">
    <th mat-header-cell *matHeaderCellDef mat-sort-header disableClear>Aantal gevraagd</th>
    <td mat-cell *matCellDef="let row">{{row.aantalGevraagd}} {{row.aantallenInAanvraagType | lowercase}}</td>
  </ng-container>

  <!-- inkoper Column -->
  <ng-container matColumnDef="inkoperNaam">
    <th mat-header-cell *matHeaderCellDef mat-sort-header disableClear>Inkoper</th>
    <td mat-cell *matCellDef="let row">{{row.inkoperNaam}}</td>
  </ng-container>

  <!-- status Column -->
  <ng-container matColumnDef="status">
    <th mat-header-cell *matHeaderCellDef>Status</th>
    <td mat-cell *matCellDef="let row">
      <mat-form-field *ngIf="!(onlyShowArchivedRegels || row.status == 6); else elseBlock">
        <mat-select [(ngModel)]="row.status" matInput (selectionChange)="onChange(row)">
          <mat-option *ngFor="let key of leverancierStatusKeys" [value]="key" [disabled]="key === 6">
            {{leverancierStatusType[key]}}
          </mat-option>
        </mat-select>
      </mat-form-field>
      <ng-template #elseBlock>{{leverancierStatusType[row.status]}}</ng-template>
    </td>
  </ng-container>

  <!-- acties Column -->
  <ng-container matColumnDef="acties">
    <th mat-header-cell *matHeaderCellDef>
      <button mat-raised-button color="accent" (click)="onSave()" [disabled]="!saveButtonIsEnabled"
        *ngIf="!onlyShowArchivedRegels">Overdragen</button>
    </th>
    <td class="actions" mat-cell *matCellDef="let row">
      <button mat-raised-button color="primary" [disabled]="row.status == 6" (click)="onDetailsOpen(row.id)">Openen</button>
    </td>
  </ng-container>

  <tr mat-header-row *matHeaderRowDef="displayedColumns" sticky></tr>
  <tr mat-row *matRowDef="let row; columns: displayedColumns;" [class.kp-modified]="row.isChanged"></tr>
</table>
